const Condition = require('./Condition');

const InspiredCondition = function(instigator, owner, battleState, potency, charges) {
  const condition = new Condition(instigator, owner, battleState, potency, charges);
  condition.handle = 'inspired';
  condition.ConditionClass = InspiredCondition;
  return condition;
};

InspiredCondition.fromCopy = function(cState, owner, instigator, battleState) {
  return InspiredCondition(instigator, owner, battleState, cState.potency, cState.charges);
};

module.exports = InspiredCondition;
